/*************************************************************************
 *
 * KLEARNOW CONFIDENTIAL
 * __________________
 *
 *  Copyright (c) 2018 - 2020 KLEARNOW Corporation.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of KLEARNOW Corporation and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to KLEARNOW Corporation
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from KLEARNOW Corporation.
 */

 import React, { Component } from 'react'
 import { Input, Form, Dropdown, Icon, Popup } from 'semantic-ui-react'
 import _ from 'lodash'
 import {propsAreEqual_NoRerenderNeeded} from '../reducer/util'
 
 export class SelecTextField extends Component {
   constructor() {
     super()
     this.state = {}
   }
   componentWillReceiveProps(nextProps) {
     if (nextProps.newValue !== this.state.newValue) {
       this.setState({ newValue: nextProps.newValue }, () => {
         this.props.fieldName === this.props.inputName + this.props.shipmentId &&
           this.props.updateValue(this.state.newValue)
       })
     }
   }
   shouldComponentUpdate(nextProps, nextState){
     if(window.slowstate)return true;

     return !propsAreEqual_NoRerenderNeeded(this.props,nextProps) || !propsAreEqual_NoRerenderNeeded(this.state,nextState);
 
   }
 
   // Detemine value to be saved from item selcted
   getValueToSave = (item) => {
     // If item has id, use that
     if (item.id) {
       // Handle null case
       if (item.id === 'NONE') {
         return '_BLANK_'
       } else {
         return item.id
       }
     } else if (item.stringVal) { // if there is stringVal, use that
       return item.stringVal
     }
     return item
   }
 
   errorPopup = (errors, label) => {
     if(!errors){
       return <label size='small'> {label}</label>;
     }else if(!errors.length){
       return <label size='small'> {label}</label>;
     }
     const error = errors.map((info, index) => {
       return (
         <div className='error' key={index}>
           * {info}
         </div>
       )
     })
     return (
       <label size='small' style={{"width": "auto"}}>
         <Popup 
           trigger={<Icon 
           name='warning sign'
           color='red' 
           />} 
           content={error || ''}
         />
         <span style={{"width": "auto", "overflow": "ellipsis"}} title={label}>
           {label}</span>
       </label>
     )
   }
 
   render() {
     const {
       options,
       inputName,
       iconPosition,
       label,
       width,
       className,
       type,
       icon,
       subLabelClass,
       value,
       dropDownValue,
       updateValue,
       updateDropDownValue,
       onBlur,
       setINPUTID,
       penClicked,
       isInteger,
       handleFocus,
       disabled,
       merchandiseId,
       shipmentId,
       shortSelectText,
       divClassName,
       selectName,
       dropdownDirectionParam='left',
       errors,
       id,
       saveOnTabOut
     } = this.props

     let { littleSearchBox,
      indexOffSet,
      highlightChanging
     }= this.state;
     let redBgColor = "";
    if(errors && errors.length){
      redBgColor = "redBgColor";
    }
    let inputFieldId = id+merchandiseId+inputName + shipmentId;
     let newLabel = this.errorPopup(errors, label);
     let subLabelText = true
     let stringsAreEqual = (str1,str2)=>{
       return (str1+"").toLowerCase()===(str2+"").toLowerCase();
     }
     let data = options === undefined ? [1, 2] : options
     let littleSearchBoxData = data.filter(aaa => {
       if (!littleSearchBox) return true;
       if (typeof aaa === "string" && stringsAreEqual(aaa, littleSearchBox)) return true
       return JSON.stringify(Object.values(aaa || {})).toLowerCase().includes(littleSearchBox.toLowerCase())
     });
     let exactMatches = data.filter(aaaa => {
       if (!littleSearchBox) return false;
       if (typeof aaaa === "string" && stringsAreEqual(aaaa, littleSearchBox)) return true
       return stringsAreEqual(aaaa.id, littleSearchBox) || stringsAreEqual(aaaa.value, littleSearchBox);
     });

     let goldSelectedIndex = -1;
     littleSearchBoxData.map((item, index) => {
                 
      if((typeof item == "string"?stringsAreEqual(item,littleSearchBox):stringsAreEqual(item.id,littleSearchBox))
        
      || littleSearchBoxData.length==1)goldSelectedIndex=index;
     });

     let checkedIndexXX = indexOffSet + goldSelectedIndex
     while(checkedIndexXX < 0)checkedIndexXX= (littleSearchBoxData.length || 1) + checkedIndexXX;
     return (
       <div
         className={`feildSelect selecTextField ${divClassName || ''} ${
           disabled ? 'disabled' : ''
           } ${redBgColor}
           ${shortSelectText?'shortSelectText':''}
           `}
       > 
       {newLabel}
         <Form.Field
           width={width}
           className={highlightChanging?"glowing-text":""}
           style={{ bottom: '0px', position: 'absolute', width: '100%' }}
         >
          
           <Input
             value={value}
             iconPosition={iconPosition}
             id={(inputName||id) + shipmentId}
             name={(inputName||id) + shipmentId}
             type={type}
             onMouseDown={e => {
              if(disabled)return;
              this.setState({lastFocusxx: Date.now()});
               e.stopPropagation()
               penClicked && penClicked(e)
               this.setState({currentValueRerenderer:Date.now()})
               this.setState({lastKeyDown: null})
             }}
             onFocus={event => {
              if(disabled)return;
               this.setState({lastFocusxx: Date.now()});
               handleFocus && handleFocus(event)
               setINPUTID &&  setINPUTID(inputName + shipmentId)
               if(this.state.focusInited && this.state.focusValueX !=  value){
                 this.setState({ wasChanged:true });
               }
               this.setState({
                focusValueX: value,
                focusInited: true,
                currentValueRerenderer:Date.now(),
                dropdownIsFocused: false,
                lastKeyDown: null
              })
             }}
             onKeyDown={(event)=>{
              this.setState({lastKeyDown: event.keyCode})
            }}
             onKeyPress={(e)=>{
              this.setState({wasChanged:true});
              if(disabled)return;
                if(e.which == 13){
                    e.preventDefault()
                    e.stopPropagation()
                    return false;
                  }
                  this.setState({currentValueRerenderer:Date.now()})
                }
              }
             onChange={event => {
              this.setState({wasChanged:true});
               updateValue(event.target.value)
               this.setState({currentValueRerenderer:Date.now()})
             }}
             disabled={disabled}
             onBlur={event => {
               if(this.props.ignoreTabOnInputField &&  this.state.lastKeyDown == 9/*tab*/)return;
               if(!this.state.wasChanged && !this.props.disableWasChanged)return;
               
              if(disabled)return;
               if (isInteger && !event.target.value) {
                 updateValue((0).toFixed(2))
               }
               onBlur(event.target.value)
               this.setState({wasChanged:false});
               setTimeout(()=>{
                document.getElementById("VALIDATE_FORM_BUTTON") && document.getElementById("VALIDATE_FORM_BUTTON").click();
               },2000);
             }}
           >
             <input
               className={className + ' form-control fix-border-bottom'}
             />
             {icon}
             {subLabelText && <p className={subLabelClass}>{subLabelText}</p>}
           </Input>

           {((this.state.dropdownIsFocused && this.state.lastFocusxx+5000>Date.now()) || this.state.mouseOverDropdown) && !disabled ? 


           <Dropdown
             lazyLoad={true}
             text={dropDownValue === '_BLANK_' ? 'NONE' : dropDownValue}
             inline
             scrolling
             className="selecTextFieldDropdown"
             open={!disabled && ((this.state.dropdownIsClicked||0) + 200 < Date.now())}
             onBlur={(eeee)=>{
              this.setState({lastKeyDown: null})
              if(disabled)return;
              this.setState({dropdownIsFocused: false});
              this.setState({highlightChanging:true});
              setTimeout(()=>{
               this.setState({highlightChanging:false});  
               },500);
               onBlur(eeee)}}
             upward={false}
             disabled={disabled || (!data || data.length<1)}
             onMouseOver={()=>{this.setState({mouseOverDropdown:true})}}
             onMouseOut={()=>{this.setState({mouseOverDropdown:false})}}
             onClick={() => {
              if(disabled)return;
              document.getElementById(inputFieldId) && document.getElementById(inputFieldId).focus()
              this.setState({lastFocusxx: Date.now(), dropdownIsFocused: true, littleSearchBox:""});
             }}
             onFocus={() => {
              this.setState({lastFocusxx: Date.now(), dropdownIsFocused: true});
               document.getElementsByClassName('active-label')[0] &&
                 document.getElementsByClassName('active-label')[0].classList.remove('active-label')
             }}
           >
             <Dropdown.Menu direction={dropdownDirectionParam} id={selectName + shipmentId}>
                 <Dropdown.Item text={littleSearchBox||<span style={{opacity:'0.3'}}>...Search</span>} />
               {((this.state.lastFocusxx||0)+120000 > Date.now())?littleSearchBoxData.map((item, index) => {
                 
                 return (
                 <Dropdown.Item
                   key={index}
                   onMouseOver={()=>{this.setState({mouseOverDropdown:true})}}
                   onMouseOut={()=>{this.setState({mouseOverDropdown:false})}}
                   style={goldSelectedIndex==index?{backgroundColor:'gold'}:{}}
                   text={
                    ((indexOffSet && (checkedIndexXX == index))?'✔ ':'  ')+
                     (item.id ? item.id : item.stringVal ? item.stringVal : item) + 
                     (item.description?` - ${item.description} `:'')
                   }
                   onClick={(eeee) => {
                    if(disabled)return;
                     updateDropDownValue(this.getValueToSave(item))
                     this.setState({currentValueRerenderer:Date.now(),dropdownIsClicked:Date.now()})
                     // fix: text field's onBlur was getting triggered upon selecting dropdown option
                     {!this?.props?.blockOnBlur && onBlur(eeee)}
                    setTimeout(()=>{
                      this.setState({lastFocusxx:Date.now()-10000});
                    },50)
                    this.setState({highlightChanging:true});
                    setTimeout(()=>{
                     this.setState({highlightChanging:false});
                     },500);
                   }}
                 />
               )}):[]}
             </Dropdown.Menu>
           </Dropdown>:
           
             <div className="ui active visible inline scrolling dropdown"
               onClick={() => {
                this.setState({lastFocusxx: Date.now(), dropdownIsFocused: true, littleSearchBox:""});
                setTimeout(()=>{
                  if(disabled)return;
                  document.getElementById(inputFieldId) && document.getElementById(inputFieldId).focus()
                },5)
              }}>
               <div className="divider text">
               {dropDownValue === '_BLANK_' ? 'NONE' : dropDownValue}
               </div>
               <i  className="dropdown icon"></i>
             </div>
           }
           <input style={{width:'1px',height:'1px',padding:'0px', border: '0px',float:'right'}} 
             id={inputFieldId}
             onFocus={() => {
              if(disabled)return;
               this.setState({
                 lastFocusxx: Date.now(),
                 dropdownIsFocused: true,
                 littleSearchBox: ""
               });
             }}
             value={littleSearchBox}
             onKeyDown={eeee =>{
              if(disabled)return;
               if(eeee.code =="ArrowDown"){
                this.setState({indexOffSet:(indexOffSet || 0)+1, lastFocusxx: Date.now()});

               } else if(eeee.code =="ArrowUp"){
                this.setState({indexOffSet:(indexOffSet || 0)-1
                  , lastFocusxx: Date.now()});
               } else  if(eeee.code =="Enter"){
                this.setState({
                  littleSearchBox:littleSearchBoxData[checkedIndexXX]?.value || littleSearchBoxData[checkedIndexXX]?.id || littleSearchBoxData[checkedIndexXX] ,
                  indexOffSet:0, 
                  lastFocusxx: Date.now()
                })
                this.setState({highlightChanging:true});
                setTimeout(()=>{
                 this.setState({highlightChanging:false});
                 },500);
                 
               } else {
                this.setState({
                  indexOffSet:0, 
                  lastFocusxx: Date.now()});

               }

             }}
             onChange={(eeee) => {
              if(disabled)return;
                this.setState({
                  littleSearchBox:eeee.target.value,
                  dropdownIsFocused:true,
                  indexOffSet:0, 
                  lastFocusxx: Date.now(),
                  mouseOverDropdown: false
                })
               }}
               onBlur={(eeee)=>{
                if(disabled)return;
                 if((littleSearchBoxData||[]).length==1){
                  updateDropDownValue(this.getValueToSave(littleSearchBoxData[0]))
                  onBlur(eeee)
                 } else if(exactMatches.length == 1 && littleSearchBox){
                  updateDropDownValue(this.getValueToSave(exactMatches[0]))
                  onBlur(eeee)
                 } else if(this.props.ignoreTabOnInputField && this.state.wasChanged){
                   onBlur(eeee);
                   this.setState({wasChanged:false});
                 }
                this.setState({currentValueRerenderer:0, dropdownIsFocused:false})
               }}
               />
         </Form.Field>
       </div>
     )
   }
 }
 
 export default SelecTextField
 